import { Feature, LineString, Polygon, sourceVector, layerVector, Circle, Fill, Stroke, Style, Text, log, abs, round, pow, sin, cos, pi, floor, tephi_map_minzoom, tephi_map_maxzoom } from '../index.js';

class Tephigramme {

  constructor(tephi_map, mapping_solftware, tephi_control, version) {
    this.tephi_map = tephi_map;
    this.mapping_solftware = mapping_solftware;
    this.tephi_control = tephi_control;
    this.version = version;
    this.cappa = 0.2854912179500E+00;
    this.tcdk = 0.2731500000000E+03;
    this.p0theta = 1000.;
    this.ni = 3300;
    this.nj = 2550;
    //this.ni=parseInt(document.getElementById(tephi_map).style.width);
    //this.nj=parseInt(document.getElementById(tephi_map).style.height);      
    this.group_list = [];
    this.fcstind = 0;
    this.lat = 0.;
    this.lon = 0.;
    this.nhours = 0;
    this.stop = 0;
    this.dateo = new Date();
    this.datev = new Date();
    this.profile_features_list = [];
    this.deg2rad = pi / 180.;
    this.etalon = 20;
    // The scaling_factor is zero for minzoom and 1.0 for maxzoom.
    this.scaling_factor = 0;
    this.set_scaling_factor();
    this.ray = 7 - 4 * (1. - this.scaling_factor);
  }

  add_reference_points(gg, tmin, tmax) {
    gg.slops();
    gg.tmin = tmin;
    gg.tmax = tmax;
    this.group_list.push(gg);
  }

  plot_reference_lines(gg) {
    var ii = this.ni;
    if (this.mapping_solftware == "Leaflet") {
      // Tracer la ligne de reference de temperature
      var jj = gg.p0.j + gg.pt * (ii - gg.p0.i);
      var polyline = L.polyline([[gg.p0.j, gg.p0.i], [jj, ii]], { color: 'red', weight: 1, }).addTo(this.map);
      // Tracer le ligne de reference de theta vers la droite
      var jj = gg.p0.j + gg.pf * (ii - gg.p0.i);
      var polyline = L.polyline([[gg.p0.j, gg.p0.i], [jj, ii]], { color: 'red', weight: 1, }).addTo(this.map);
      // Tracer la ligne de reference de theta vers la gauche
      ii = 0;
      jj = gg.p0.j + gg.pf * (ii - gg.p0.i);
      var polyline = L.polyline([[gg.p0.j, gg.p0.i], [jj, ii]], { color: 'blue', weight: 1, }).addTo(this.map);
    } else if (this.mapping_solftware == "OpenLayers") {
      // Tracer la ligne de reference de temperature
      var jj = gg.p0.j + gg.pt * (ii - gg.p0.i);
      var trash = trash = this.segment([[gg.p0.i, gg.p0.j], [ii, jj]]);
      // Tracer le ligne de reference de theta vers la droite
      var jj = gg.p0.j + gg.pf * (ii - gg.p0.i);
      trash = this.segment([[gg.p0.i, gg.p0.j], [ii, jj]]);
      // Tracer la ligne de reference de theta vers la gauche
      ii = 0;
      jj = gg.p0.j + gg.pf * (ii - gg.p0.i);
      trash = this.segment([[gg.p0.i, gg.p0.j], [ii, jj]]);
    }
  }
  set_scaling_factor() {
    // fraction is 0 at minzoom and one at maxzoom
    this.scaling_factor = (tephi_map_maxzoom - this.tephi_map.getView().getZoom()) / (tephi_map_maxzoom - tephi_map_minzoom);
  }

  reqListener() {
    //alert('dans reqListener');
    if (this.readyState == XMLHttpRequest.DONE) {
      //alert(this.status);
      if (this.status == 200) {
        this.myJson = eval(this.responseText);
        //alert(this.myJson);
        if (this.myJson.status != 'OK') {
          //alert(this.myJson.status);
          alert('ERREUR : ' + this.myJson.status);
        }
        this.plot_json_data(this.myJson);
      } else {
        alert('Probleme avec la requete RDPS : ' + this.status + this.responseText);
      }
    }
  }

  plot_profile_wms(p0, diag, temp, pres, nom_variabale ,color = 'red') {
    var width = 1 + 1.5 * (1. - this.scaling_factor);
    var count = 0;
    var last_level_plotted;
    if(pres[0] >= p0){
      alert("Le point le plus haut du profil de "+ nom_variabale +" est à "+ pres[0] +" hPa, ce qui est sous la surface qui a une pression de "+Math.ceil(p0)+" hPa.\nVeillez à mettre un niveau au-dessus de la surface pour le profile de "+nom_variabale);
      return;
    };
    for (var k = 0; k < temp.length; k++) {
      //if pressure is below surface we don't plot it.
      if (pres[k] <= p0) {
        last_level_plotted = pres[k];
        var ijp = this.temp_pres_to_i_j(temp[k], pres[k]);
        //L.circle(ijp, {radius: 5, color: color, weight: 1.}).addTo(this.map);
        //this.profile_features_list.push(this.ol_circle(ijp,color,width,this.ray));
        //this.profile_features_list.push(this.ol_circle(ijp,'black',width,2*this.ray));
        this.profile_features_list.push(this.ol_circle(ijp, color, width, this.ray));
        if (count == 0) {
          //var myLayerGroup = L.layerGroup(L.circle(ijp, {radius: 5, color: color, weight: 1.}));
          //this.profile_features_list.push(this.ol_circle(ijp,color,width,this.ray));
        }
        //myLayerGroup.addLayer(L.circle(ijp, {radius: 5, color: color, weight: 1.}));
        if (count != 0) {
          //this.polyline = L.polyline([ijm,ijp], {color: color, weight: 1}).addTo(this.map);
          //myLayerGroup.addLayer(L.polyline([ijm,ijp], {color: color, weight: 1}))
          this.profile_features_list.push(this.segment([ijm, ijp], color, width));
        }
        count++;
      }
      var ijm = ijp;
    }
    // Plot diag point ?
    // If there is one or more levels between p0 et the last levels plotted then
    // we don't plot the diag level.
    // Find index of last_level_plotted in tephi_control.levels list
    var ind;
    for (let i = 0; i < this.tephi_control.levels.length; i++) {
      if (this.tephi_control.levels[i] > last_level_plotted) {
        ind = i;
        break;
      }
    }
    if (ind < this.tephi_control.levels.length - 1) {
      if (this.tephi_control.levels[ind + 1] < p0) {
        return;
      }
    }
    var ijp = this.temp_pres_to_i_j(diag, p0);
    //this.profile_features_list.push(this.ol_circle(ijp,'black',width,2*this.ray));
    this.profile_features_list.push(this.ol_circle(ijp, color, width, this.ray));
    this.profile_features_list.push(this.segment([ijm, ijp], color, width));
    //myLayerGroup.addTo(this.map);
    //return myLayerGroup;
  }
  plot_GZ_profile_wms(p0, diag, data, pres, T_imax, p_imax, color = 'black') {
    for (var k = -1; k < data.length; k++) {
      var gz_val;
      var pp;
      var offset = 0;
      var extra = '';
      var space_for_wind = 0;
      if (this.tephi_control.id_height_agl.checked) {
        offset = diag;
      }
      if (k == -1) {
        gz_val = diag - offset;
        pp = p0
      } else {
        gz_val = data[k] - offset;
        pp = pres[k];
      }
      //If pressure is below surface we don't plot it.
      if (pp >= p0 && k != -1) {
        continue;
      }
      // Trouver la Temperature sur la droite verticale sur le tephi qui passe par
      // le point (T_imax, p_imax)
      var TT = this.get_T_on_vertical_line_at_p(T_imax + 3., pp, T_imax + 3., p_imax);
      var ijc = this.temp_pres_to_i_j(TT, pp);

      var textAdjust = 'left';
      if (pp == p0) {
        extra = ' niveau du sol '
      }
      if (this.tephi_control.id_wind.checked) {
        space_for_wind = 5 * this.etalon * this.scaling_factor;
      }
      if (this.tephi_control.id_plot_wind_val.checked) {
        space_for_wind = space_for_wind + 5 * this.etalon * this.scaling_factor;
      }
      var ijm = [ijc[0] - .1 + space_for_wind, ijc[1]];
      var ijp = [ijc[0] + .1 + space_for_wind, ijc[1]];
      this.profile_features_list.push(this.segment_text([ijm, ijp], " " + round(gz_val).toString() + ' m ' + extra, textAdjust));
    }
  }
  plot_winds_wms(p0, wind_module_diag, wind_module, wind_dir_diag, wind_dir, pres, i_max, T_imax, p_imax, color = 'black') {
    // This code is an adaptation of R code git@gitlab.com:toutoumeteo/R_tephi.git
    //
    //
    //
    //    
    //     |   \   \
    //    wy0   \   \
    //     |     \wxd\
    //           -------------
    //      ->| w |<-         ijc
    //          x 
    //          0
    //
    var ijm = 0;
    var ijp = 0;
    var ij3 = 0;
    var corp = this.etalon + 2 * this.etalon * this.scaling_factor;
    var width = 1 + 2 * (1. - this.scaling_factor);
    var alpha = 0.;
    var wx0 = 0.15 * corp;
    var wy0 = -0.25 * corp;
    var wxd = .17 * corp;
    var xx = wx0;
    var total = 0;
    var nb_50 = 0;
    var nb_10 = 0;
    var nb_5 = 0;
    var ijc;
    var cosa = 0.;
    var sina = 0.;
    var xx = corp;
    var yy = 0;
    var module = 0;
    var dir = -1;
    var pp = -1;
    for (var k = -1; k < wind_dir.length; k++) {
      if (k == -1) {
        module = wind_module_diag;
        dir = wind_dir_diag
        pp = p0
      } else {
        module = wind_module[k];
        dir = wind_dir[k];
        pp = pres[k];
      }
      //If pressure is below surface we don't plot it.
      if (pp >= p0 && k != -1) {
        continue;
      }
      total = 0;
      // Trouver la Temperature sur la droite verticale sur le tephi qui passe par
      // le point (T_imax, p_imax)
      var TT = this.get_T_on_vertical_line_at_p(T_imax + 3., pp, T_imax + 3., p_imax);
      ijc = this.temp_pres_to_i_j(TT, pp);
      //ijc[0]=i_max+corp+wx0*1.2+this.ray;
      //ijc[0]=i_max;
      alpha = this.deg2rad * (270 - dir);
      cosa = cos(alpha);
      sina = sin(alpha);
      // Draw 50 knots flags
      nb_50 = floor(module / 50);
      if (nb_50 > 0) {
        for (var i = 0; i < nb_50; i++) {
          xx = corp - i * wxd;
          yy = 0;
          // Apply rotation matrix
          ijm = [ijc[0] - (xx * cosa - yy * sina), ijc[1] - (xx * sina + yy * cosa)];
          xx = corp + wx0 - i * wxd;
          yy = wy0;
          // Apply rotation matrix
          ijp = [ijc[0] - (xx * cosa - yy * sina), ijc[1] - (xx * sina + yy * cosa)];
          xx = corp - i * wxd - .85 * wxd;
          yy = 0;
          // Apply rotation matrix
          ij3 = [ijc[0] - (xx * cosa - yy * sina), ijc[1] - (xx * sina + yy * cosa)];
          this.profile_features_list.push(this.segment([ijm, ijp], color, width));
          this.profile_features_list.push(this.segment([ijp, ij3], color, width));
          //this.profile_features_list.push(this.filled_triangle([ijm,ijp,ij3]));
          total = total + 50
        }
      }
      // draw 10 knots barbs                  
      nb_10 = floor((module - total) / 10.);
      for (var i = 0; i < nb_10; i++) {
        xx = corp - nb_50 * wxd - i * wxd;
        yy = 0;
        // Apply rotation matrix
        ijm = [ijc[0] - (xx * cosa - yy * sina), ijc[1] - (xx * sina + yy * cosa)];
        xx = xx + wx0;
        yy = wy0;
        // Apply rotation matrix
        ijp = [ijc[0] - (xx * cosa - yy * sina), ijc[1] - (xx * sina + yy * cosa)];
        this.profile_features_list.push(this.segment([ijm, ijp], color, width));
        total = total + 10;
      }
      if (module - total >= 2.5) {
        if (nb_50 + nb_10 == 0) {
          xx = corp - wxd;
        } else {
          xx = corp - (nb_50 + nb_10 - 1) * wxd - wxd;
        }
        yy = 0;
        // Apply rotation matrix
        ijm = [ijc[0] - (xx * cosa - yy * sina), ijc[1] - (xx * sina + yy * cosa)];
        xx = xx + wx0 / 2.;
        yy = wy0 / 2.;
        // Apply rotation matrix
        ijp = [ijc[0] - (xx * cosa - yy * sina), ijc[1] - (xx * sina + yy * cosa)];
        this.profile_features_list.push(this.segment([ijm, ijp], color, width));
      }
      if (module > 2.5) {
        // Corp de la barbule
        ijp = [ijc[0] - corp * cosa, ijc[1] - corp * sina];
        this.profile_features_list.push(this.segment([ijc, ijp], color, width));
      } else {
        this.profile_features_list.push(this.ol_circle(ijc, color, width, corp * .15));
      }
      // Did not find plain text in openlayers. Must draw a very short line one pixel long and
      // put text on it. To best hide point, put segment ponts on each side of centre point ijc
      ijm = [ijc[0] - .1, ijc[1]];
      ijp = [ijc[0] + .1, ijc[1]];
      var textAdjust = 'left';
      if (dir < 180) {
        textAdjust = 'right';
      }
      if (this.tephi_control.id_plot_wind_val.checked) {
        this.profile_features_list.push(this.segment_text([ijm, ijp], " " + round(module).toString() + ' kts ', textAdjust));
      }
    }
  }
  get_T_on_vertical_line_at_p(T_trial, pres, T_imax, p_imax) {
    // The following points define the slope of vertical lines on the tephi
    const T0 = 16. + this.tcdk;
    const lntheta0 = log(290.);
    const T1 = -58. + this.tcdk;
    const lntheta1 = log(415.);
    const slope = (T1 - T0) / (lntheta1 - lntheta0);
    // Define the vertical line passing by point t_imax, p_imax    
    const bb = (T_imax + this.tcdk) - (slope * log(this.theta_from_temp_pres(T_imax, p_imax)));
    // Iteration de Newton-Raphson 
    var TTm = T_trial + this.tcdk;
    var TTp;
    for (let i = 0; i < 100; i++) {
      // Fonction to find the zero of
      var ff = slope * log(this.theta_from_temp_pres(TTm - this.tcdk, pres)) - TTm + bb;
      // Its derivative
      var fp = slope / TTm - 1.;
      TTp = TTm - ff / fp;
      if (abs(TTp - TTm) < 0.1) { break };
      TTm = TTp;
    }
    return TTp - this.tcdk;
  }

  clear_profile() {
    for (var i = 0; i < this.profile_features_list.length; i++) {
      this.profile_features_list[i].clear();
    }
  }

  //redraw_profile(){
  //  for (var i = 0; i < this.profile_features_list.length; i++){
  //    this.profile_features_list[i].redraw();
  //  }
  //}

  remove_all_layers(map) {
    map.removeLayer(this.temp_profile);
    map.removeLayer(this.td_profile);
    //map.eachLayer(function (layer) {
    //  map.removeLayer(layer);
    //});
    //this.map.eachLayer(function(layer){
    //  layer.removeLayer();
    //});
    //for(var i = 0; i < this.mapMarkers.length; i++){
    //  this.map.removeLayer(this.mapMarkers[i]);
    //}
  }


  theta_from_temp_pres(temp, pres) {
    return (temp + this.tcdk) * pow(this.p0theta / pres, this.cappa);
  }

  pres_from_temp_theta(temp, theta) {
    return this.p0theta * pow((temp + this.tcdk) / theta, 1. / this.cappa);
  }

  temp_theta_to_i_j(temp, theta) {
    return this.temp_phi_to_i_j(temp, log(theta));
  }

  temp_pres_to_i_j(temp, pres) {
    return this.temp_phi_to_i_j(temp, log((temp + this.tcdk) * pow(this.p0theta / pres, this.cappa)));
  }

  temp_phi_to_i_j(temp, phi) {
    // Loop on refernce point to find which one supports actual temperature
    // TODO handle error if temp do not fit in anay points group.
    var found = 0;
    for (var k = 0; k < this.group_list.length; k++) {
      var g = this.group_list[k];
      if (temp > g.tmin && temp <= g.tmax) {
        found = 1;
        var pp_t = temp;
        // Calul de phi=ln(theta)
        var pp_f = phi;
        //Trouver le point ii,jj sur l'isotherme defini par g.p0 et g.p1 ou f = pp_f
        var ii = g.p0.i + (g.p1.i - g.p0.i) / (g.p1.f - g.p0.f) * (pp_f - g.p0.f);
        var jj = g.p0.j + (g.p1.j - g.p0.j) / (g.p1.f - g.p0.f) * (pp_f - g.p0.f);
        //var sol = L.latLng([ jj, ii]);
        //L.marker(sol).addTo(this.map);
        // A partir de ce point suivre theta constant jusqua pp_t
        ii = ii + (g.p2.i - g.p0.i) / (g.p2.t - g.p0.t) * (pp_t - g.p0.t);
        jj = jj + (g.p2.j - g.p0.j) / (g.p2.t - g.p0.t) * (pp_t - g.p0.t);
        //var sol = L.latLng([ jj, ii]);
        //L.marker(sol).addTo(this.map);
        if (this.mapping_software == "Leaflet") {
          return [jj, ii];
        } else {
          return [ii, jj];
        }
      }
    }
    if (found == 0) {
      alert("No point group fits temperature or td");
      return [0, 0];
    }
  }

  plot_point(temp, pres) {
    L.marker(L.latLng(this.temp_pres_to_i_j(temp, pres))).addTo(this.map);
  }
  plot_point_t_theta(temp, theta) {
    L.marker(L.latLng(this.temp_theta_to_i_j(temp, theta))).addTo(this.map);
  }

  plot_control_points() {
    // To validate tephi positioning plot control points
    for (var temp = -60; temp <= 40; temp = temp + 5) {
      for (var pres = 1050; pres >= 300; pres = pres - 50) {
        //L.marker(L.latLng(this.temp_pres_to_i_j(temp,pres))).addTo(this.map);
        var trash = this.ol_circle(this.temp_pres_to_i_j(temp, pres));
      }
    }
    for (var temp = -80; temp <= -30; temp = temp + 5) {
      for (var pres = 250; pres >= 100; pres = pres - 10) {
        //L.marker(L.latLng(this.temp_pres_to_i_j(temp,pres))).addTo(this.map);
        trash = this.ol_circle(this.temp_pres_to_i_j(temp, pres));
      }
    }
  }

  inc_hr() {
    this.fcstind++;
    if (this.fcstind >= this.nhours) {
      this.fcstind = 0;
    }
    this.plot_json_data();
    document.getElementById('id_fcst').selectedIndex = this.fcstind;
  }
  dec_hr() {
    this.fcstind--;
    if (this.fcstind < 0) {
      this.fcstind = this.nhours - 1;
    }
    document.getElementById('id_fcst').selectedIndex = this.fcstind;
    this.plot_json_data();
  }
  // add optional argument offserY with default to 0
  segment_text(points, text, textAlign) {
    var text_size = 10 + 20 * (1. - this.scaling_factor);
    var style = new Style({
      stroke: new Stroke({
        color: 'Black',
        width: 1
      }),
      // Ne marche pas :
      //backgroundFill: new Fill({
      //  color: 'white'
      //}),
      text: new Text({
        textAlign: textAlign,
        font: text_size + 'px sans-serif',
        text: text
      })
    });
    var featureLine = new Feature({
      geometry: new LineString(points)
    });
    featureLine.setStyle(style);
    //featureLine.getStyle().getText().setText('new content');
    //featureLine.setText(text);
    var sourceLine = new sourceVector({
      features: [featureLine]
    });
    var vectorLine = new layerVector({
      source: sourceLine
    });
    this.tephi_map.addLayer(vectorLine);
    return sourceLine;
  }

  segment(points, color = 'red', width = 1) {
    var style = new Style({
      stroke: new Stroke({
        color: color,
        width: width
      }),
    });
    var featureLine = new Feature({
      geometry: new LineString(points)
    });
    featureLine.setStyle(style);
    var sourceLine = new sourceVector({
      features: [featureLine]
    });
    var vectorLine = new layerVector({
      source: sourceLine
    });
    this.tephi_map.addLayer(vectorLine);
    return sourceLine;
  }

  filled_triangle(points, color = 'black') {
    var style = new Style({
      stroke: new Stroke({
        color: color,
        width: 1
      }),
      fill: new Fill({
        color: color
      })
    });
    var featurePoly = new Feature({
      geometry: new Polygon(points)
    });
    featurePoly.setStyle(style);
    var sourcePoly = new sourceVector({
      features: [featurePoly]
    });
    var vectorPoly = new layerVector({
      source: sourcePoly
    });
    this.tephi_map.addLayer(vectorPoly);
    return sourcePoly;
  }

  ol_circle(point, color = 'red', width = 1, ray = 7) {
    var style = new Style({
      stroke: new Stroke({
        color: color,
        width: width
      }),
    });
    var featureCircle = new Feature({
      geometry: new Circle(point, ray)
    });
    featureCircle.setStyle(style);
    var sourceCircle = new sourceVector({
      features: [featureCircle]
    });
    var vectorCircle = new layerVector({
      source: sourceCircle
    });
    this.tephi_map.addLayer(vectorCircle);
    return sourceCircle;
  }
}

class Tephi_point {
  constructor(t, f, i, j) {
    this.t = t;
    this.f = log(f);
    this.i = i;
    this.j = j;

  }
}

class Tephi_reference_points {

  // The reference lines are difined by points p0, p1 and p2
  // To plot these in the thephi use method plot_reference_lines()
  // Example for isotherme -30 C and adiabatic 310 K
  //
  //           p1
  //      
  //       -30C
  //      
  //    p0
  //
  //      theta=310
  //
  //               p2
  //
  // Note tha point p2 may be positioned on the other side
  // of isotherme like in the following figure
  //
  //           p2            p1
  //      
  //                     -30 C
  //         theta=310
  //                   p0
  //

  constructor(
    t0, f0, i0, j0,
    t1, f1, i1, j1,
    t2, f2, i2, j2,
  ) {
    this.p0 = new Tephi_point(t0, f0, i0, j0);
    this.p1 = new Tephi_point(t1, f1, i1, j1);
    this.p2 = new Tephi_point(t2, f2, i2, j2);
    this.tmin = -100.;
    this.tmax = 50.;
  }

  slops() {
    if (abs(this.p0.f - this.p2.f) / this.p0.f > 1.e-4) {
      alert("Tephi_reference_points theta value should be the same for p0 and p2 but are not. Please review construction oj objects Tephi_reference_points");
    }
    // Calcul de la pente des isothermes sur la carte
    this.pt = (this.p1.j - this.p0.j) / (this.p1.i - this.p0.i);
    // En pricipe this.pf = 1/this.pt mais le scanner introduit une legere distortion dans l'hortogonalite.
    this.pf = (this.p2.j - this.p0.j) / (this.p2.i - this.p0.i);
  }

}

class Tephi_control {
  constructor({ id_plot_wind = null,
    id_model = null, id_datev_message = null, id_datev_menu = null,
    id_temp = null, id_T_max_level = null, id_T_min_level = null,
    id_td = null, id_Td_max_level = null, id_Td_min_level = null,
    id_wind = null, id_V_max_level = null, id_V_min_level = null,
    id_message = null, id_plot_wind_val = null,
    id_height_no = null, id_height_agl = null, id_height_asl = null,
    id_product_displayed = null, levels = null }) {
    this.id_plot_wind = id_plot_wind;
    this.id_model = id_model,
      this.id_datev_message = id_datev_message;
    this.id_datev_menu = id_datev_menu;
    this.id_datev_menu = id_datev_menu;
    this.id_temp = id_temp;
    this.id_T_max_level = id_T_max_level;
    this.id_T_min_level = id_T_min_level;
    this.id_td = id_td;
    this.id_Td_max_level = id_Td_max_level;
    this.id_Td_min_level = id_Td_min_level;
    this.id_wind = id_wind;
    this.id_V_max_level = id_V_max_level;
    this.id_V_min_level = id_V_min_level;
    this.id_message = id_message;
    this.id_plot_wind_val = id_plot_wind_val;
    this.id_height_no = id_height_no;
    this.id_height_agl = id_height_agl;
    this.id_height_asl = id_height_asl;
    this.id_product_displayed = id_product_displayed;
    this.levels = levels;
    this.cook_life = 100;
  }
  get_model() {
    return this.id_model.options[this.id_model.selectedIndex].value;
  }
  get_datev_menu_value() {
    return this.id_datev_menu.options[this.id_datev_menu.selectedIndex].value;
  }
  get_datev_menu_text() {
    return this.id_datev_menu.options[this.id_datev_menu.selectedIndex].text;
  }
  init_from_cookies() {
    var model_ind = this.lit_cook('tephi_id_model_ind');
    if (model_ind != "") {
      this.id_model.selectedIndex = model_ind;
    }
    var id_temp_checked = this.lit_cook('tephi_id_temp_checked');
    if (id_temp_checked == "") {
      // Check T by default
      this.id_temp.checked = true;
    } else {
      var value = false;
      if (id_temp_checked == 'T') { value = true }
      this.id_temp.checked = value;
    }
    var id_td_checked = this.lit_cook('tephi_id_td_checked');
    if (id_td_checked == "") {
      // Check Td by default
      this.id_td.checked = true;
    } else {
      var value = false;
      if (id_td_checked == 'T') { value = true }
      this.id_td.checked = value;
    }
    var id_wind_checked = this.lit_cook('tephi_id_wind_checked');
    if (id_wind_checked == "") {
      this.id_wind.checked = false;
    } else {
      var value = false;
      if (id_wind_checked == 'T') { value = true }
      this.id_wind.checked = value;
    }
    var id_plot_wind_val_checked = this.lit_cook('tephi_id_plot_wind_val_checked');
    if (id_plot_wind_val_checked == "") {
      this.id_plot_wind_val.checked = false;
    } else {
      var value = false;
      if (id_plot_wind_val_checked == 'T') { value = true }
      this.id_plot_wind_val.checked = value;
    }
    var id_height_no_checked = this.lit_cook('tephi_id_height_no_checked');
    if (id_height_no_checked == "") {
      this.id_height_no.checked = false;
    } else {
      var value = false;
      if (id_height_no_checked == 'T') { value = true }
      this.id_height_no.checked = value;
    }
    var id_height_agl_checked = this.lit_cook('tephi_id_height_agl_checked');
    if (id_height_agl_checked == "") {
      this.id_height_agl.checked = false;
    } else {
      var value = false;
      if (id_height_agl_checked == 'T') { value = true }
      this.id_height_agl.checked = value;
    }
    // If none is checked, default is no height
    if (!this.id_height_no.checked && !this.id_height_agl.checked && !this.id_height_asl.checked) {
      this.id_height_no.checked = true;
    }
    var id_height_asl_checked = this.lit_cook('tephi_id_height_asl_checked');
    if (id_height_asl_checked == "") {
      this.id_height_asl.checked = false;
    } else {
      var value = false;
      if (id_height_asl_checked == 'T') { value = true }
      this.id_height_asl.checked = value;
    }
    var id_T_max_level_ind = this.lit_cook('tephi_id_T_max_level_ind');
    if (id_T_max_level_ind != "") {
      this.id_T_max_level.selectedIndex = id_T_max_level_ind;
    }
    var id_T_min_level_ind = this.lit_cook('tephi_id_T_min_level_ind');
    if (id_T_min_level_ind != "") {
      this.id_T_min_level.selectedIndex = id_T_min_level_ind;
    }
    var id_Td_max_level_ind = this.lit_cook('tephi_id_Td_max_level_ind');
    if (id_Td_max_level_ind != "") {
      this.id_Td_max_level.selectedIndex = id_Td_max_level_ind;
    }
    var id_Td_min_level_ind = this.lit_cook('tephi_id_Td_min_level_ind');
    if (id_Td_min_level_ind != "") {
      this.id_Td_min_level.selectedIndex = id_Td_min_level_ind;
    }
    var id_V_max_level_ind = this.lit_cook('tephi_id_V_max_level_ind');
    if (id_V_max_level_ind != "") {
      this.id_V_max_level.selectedIndex = id_V_max_level_ind;
    }
    var id_V_min_level_ind = this.lit_cook('tephi_id_V_min_level_ind');
    if (id_V_min_level_ind != "") {
      this.id_V_min_level.selectedIndex = id_V_min_level_ind;
    }
  }
  set_cook_from_id(id) {
    // Note a switch case dod not work with string!
    if (id == "id_model") {
      this.cre_cook('tephi_id_model_ind', this.id_model.selectedIndex);
    } else if (id == "id_temp") {
      var value = 'F'
      if (this.id_temp.checked) { value = 'T' }
      this.cre_cook('tephi_id_temp_checked', value);
    } else if (id == "id_td") {
      var value = 'F'
      if (this.id_td.checked) { value = 'T' }
      this.cre_cook('tephi_id_td_checked', value);
    } else if (id == "id_wind") {
      var value = 'F'
      if (this.id_wind.checked) { value = 'T' }
      this.cre_cook('tephi_id_wind_checked', value);
    } else if (id == "id_plot_wind_val") {
      var value = 'F'
      if (this.id_plot_wind_val.checked) { value = 'T' }
      this.cre_cook('tephi_id_plot_wind_val_checked', value);
    }
    else if (id == "id_height_no") {
      var value = 'F'
      if (this.id_height_no.checked) {
        value = 'T';
        this.cre_cook('tephi_id_height_agl_checked', 'F');
        this.cre_cook('tephi_id_height_asl_checked', 'F');
      }
      this.cre_cook('tephi_id_height_no_checked', value);
    } else if (id == "id_height_agl") {
      var value = 'F'
      if (this.id_height_agl.checked) {
        value = 'T';
        this.cre_cook('tephi_id_height_no_checked', 'F');
        this.cre_cook('tephi_id_height_asl_checked', 'F');
      }
      this.cre_cook('tephi_id_height_agl_checked', value);
    } else if (id == "id_height_asl") {
      var value = 'F'
      if (this.id_height_asl.checked) {
        value = 'T';
        this.cre_cook('tephi_id_height_no_checked', 'F');
        this.cre_cook('tephi_id_height_agl_checked', 'F');
      }
      this.cre_cook('tephi_id_height_asl_checked', value);
    } else if (id == 'id_T_max_level') {
      this.cre_cook('tephi_id_T_max_level_ind', this.id_T_max_level.selectedIndex);
    } else if (id == 'id_T_min_level') {
      this.cre_cook('tephi_id_T_min_level_ind', this.id_T_min_level.selectedIndex);
    } else if (id == 'id_Td_max_level') {
      this.cre_cook('tephi_id_Td_max_level_ind', this.id_Td_max_level.selectedIndex);
    } else if (id == 'id_Td_min_level') {
      this.cre_cook('tephi_id_Td_min_level_ind', this.id_Td_min_level.selectedIndex);
    } else if (id == 'id_V_max_level') {
      this.cre_cook('tephi_id_V_max_level_ind', this.id_V_max_level.selectedIndex);
    } else if (id == 'id_V_min_level') {
      this.cre_cook('tephi_id_V_min_level_ind', this.id_V_min_level.selectedIndex);
    } else {
      alert("Internal error in class Tephi_control, please add id " + id + " to switch case");
    }
  }
  cre_cook(nom, contenu) {
    var jours = 100;
    var expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + jours * 24 * 3600 * 1000);
    document.cookie = nom + "=" + escape(contenu) + ";expires=" + expireDate.toGMTString() + ";path=/;SameSite=None;secure";
  }
  lit_cook(nom) {
    var deb, fin;
    deb = document.cookie.indexOf(nom + "=");
    if (deb >= 0) {
      deb += nom.length + 1;
      fin = document.cookie.indexOf(";", deb);
      if (fin < 0) fin = document.cookie.length;
      return unescape(document.cookie.substring(deb, fin));
    }
    return "";
  }
  check_td_levels() {
    if (!this.id_td.checked) { return }
    if (!this.id_temp.checked) {
      alert('Vous devez cocher la variable température pour avoir le point de rosée');
      this.id_temp.checked = true;
    }
    var message = "";
    var p1 = this.get_pres_val(this.id_Td_max_level);
    var p2 = this.get_pres_val(this.id_T_max_level);
    if (p1 > p2) {
      message = "Le niveaux le plus bas de Td doit être égal ou au-dessus de celui de T.";
      this.id_Td_max_level.selectedIndex = this.id_T_max_level.selectedIndex;
    }
    var p1 = this.get_pres_val(this.id_Td_min_level);
    var p2 = this.get_pres_val(this.id_T_min_level);
    if (p1 < p2) {
      message = message + "Le niveaux le plus haut de Td doit égal ou sous celui de T.";
      this.id_Td_min_level.selectedIndex = this.id_T_min_level.selectedIndex;
    }
    if (message != "") {
      alert(message);
      return;
    }
    return;
  }
  get_pres_val(id_menu) {
    var pp = id_menu.options[id_menu.selectedIndex].value;
    if (pp == "Surface") {
      return 2000;
    } else {
      return parseInt(pp);
    }
  }
}

export { Tephigramme, Tephi_reference_points, Tephi_control };
